import React from 'react'
import {DatePicker} from "antd";
import {Field} from "./index";
import moment from "moment";
import {FieldBase} from "./components/FieldBase";

export class FieldRangeDate extends Field {

  constructor(obj={}) {
    super(obj);
  }

  getComponent (form) {
    const { RangePicker } = DatePicker;
    const dateFormat = ['DD/MM/YYYY'];

    const RangeDateInput = ({ value, onChange }) => {
      const momentValue = Array.isArray(value)
        ? value.map(v => moment.isMoment(v) ? v : moment(v, ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD-MM-YYYY'], true))
        : undefined;

      return (
        <RangePicker
          format={dateFormat}
          style={{ width: '100%' }}
          value={momentValue}
          onChange={(dates) => onChange(dates ? dates.map(d => d.format('YYYY-MM-DD')).join(',') : null)}
        />
      );
    };

    return () => (
      <FieldBase condition={this.condition} form={form} size={this.size} label={this.label} name={this.name} value={this.value} help={this.help} rules={this.rules}>
        <RangeDateInput />
      </FieldBase>);
  }

  transformToField = (data) => {
    this.name = data.name;
    this.label = data.label;
    this.type = data.type;
    this.size = data.size ?? this.size;
    this.condition = data.condition ?? true;
    this.rules = data.rules;
    this.value = this.transformValueToRange(data.value ?? data.defaultValue);

    return this;
  }

  transformValueToRange = (str) => {
    if (!str) return undefined;
    const parts = String(str).split(',');
    const valid = parts.length === 2 && parts.every(p => moment(p, ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD-MM-YYYY'], true).isValid());
    return valid ? parts : undefined;
  }

  transformValueToField = (data) => {
    let result = data.split(',');
    result[0] = moment(result[0], ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD-MM-YYYY'], true);
    result[1] = moment(result[1], ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD-MM-YYYY'], true);
    return result;
  }

}


